import React from 'react';
import {FiX} from "react-icons/fi";
import dayjs from "dayjs";
import FlatPickr from "@/components/LazyFlatPicker.tsx";

export default function RangePicker({
                         value,
                         onChange,
                         placeholder,
                     }:{
    value?: [string, string],
    onChange: (value: [string, string]) => void,
    placeholder?: string
 }) {
    return (
        <div className={"input w-full input-bordered"}>
            <FlatPickr
                config={{
                    mode:'range',
                    dateFormat: 'M j, Y',
                }}
                value={value.filter((i)=>!!i)}
                placeholder={placeholder}
                onChange={(dates) => {
                    onChange(
                        dates ? dates?.filter((i)=>!!i)
                        .map((i)=>dayjs(i).format('YYYY-MM-DD')) : null)
                }}
            />
            {
                value && value.filter((i)=>!!i).length === 2 ?
                    <button onClick={()=>{
                        alert('value')
                        onChange(null)
                    }} className="input-group-text" id="basic-addon1">
                        <FiX />
                    </button> : null
            }
        </div>
    );
}
